import React, { Fragment, useEffect, useState } from "react";
import { UncontrolledTooltip } from "reactstrap";

// redux toolkit
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { fetchEarningInvoice } from "../../slices/apps/agencySlices";

const EarningInvoiceModal = ({ id }) => {
  const dispatch = useDispatch();

  const fetchData = async () => {
    try {
      await dispatch(fetchEarningInvoice(id));
    } catch (error) {
      console.error("Failed:", error);
    }
  };

  function tog_large(e) {
    if (e) {
      fetchData();
    }
  }

  return (
    <Fragment>
      <span
        id={`earningInvoice-tooltipTop-${id}`}
        style={{
          display: "flex",
          cursor: "pointer",
          padding: "3px",
        }}
        onClick={() => tog_large(true)}
      >
        <i
          className="bx bx-file-blank text-dark"
          style={{
            fontSize: "20px",
          }}
        />
      </span>

      <UncontrolledTooltip
        placement="top"
        target={`earningInvoice-tooltipTop-${id}`}
      >
        Fatura Görüntüle
      </UncontrolledTooltip>
    </Fragment>
  );
};

export default EarningInvoiceModal;
